import { useCallback } from 'react';

import { useDrawer } from '@cast/design-system';

import { AllActivityDrawer } from './AllActivityDrawer';

export const useAllActivityDrawer = (nodeName?: string) => {
  const { open } = useDrawer();

  const openAllActivity = useCallback(() => {
    open({ component: AllActivityDrawer, props: { nodeName } });
  }, [open, nodeName]);

  return { openAllActivity };
};
